import { MODIFY_ORDER_TYPE_PROMOTION, FREEDELIVERY } from '../../../constants';
import { isDelivery } from '../OrderModal.service';

interface RenderPromotionBlocProps {
    order: any;
    orderType: string;
    reconversionType: string;
    type: string | number;
    promoCode?: string;
    managementFee: number | null;
    userServicePrice: number;
    displayPriceFormat: (value: number | string) => string;
    mainColor: { secondaryColor: string };
    classes: Record<string, any>;
}
export const renderPromotionBloc = ({
    order,
    orderType,
    reconversionType,
    type,
    promoCode,
    managementFee,
    userServicePrice,
    displayPriceFormat,
    mainColor,
    classes,
}: RenderPromotionBlocProps) => {
    const isClickAndCollectPromo =
        reconversionType === MODIFY_ORDER_TYPE_PROMOTION.CLICK_AND_COLLECT;

    const hasPromoCode =
        promoCode && type !== FREEDELIVERY
            ? `${!isNaN(type as number) ? displayPriceFormat(type) : type
            } (${promoCode})`
            : 'Aucune';

    const hasMarketingDiscount = !!order?.marketingCampaignPromoAmount;
    const hasFreeDelivery = type === FREEDELIVERY || order?.freeDelivery;
    const hasDelivery = isDelivery(orderType);
    const hasFees = managementFee !== null;

    const shouldShowHrBeforeDelivery =
        (hasDelivery || hasFees || hasFreeDelivery) &&
        (!isClickAndCollectPromo || hasMarketingDiscount);

    const renderDashedHr = (condition: boolean) =>
        condition ? <hr style={classes.hrDashed} /> : null;

    return (
        <>
            {!isClickAndCollectPromo && (
                <p style={classes.orderDetailStyle}>
                    <p>Promotion :</p>
                    {hasPromoCode}
                </p>
            )}

            {hasMarketingDiscount && (
                <p style={classes.orderDetailStyle}>
                    <p style={{ color: mainColor.secondaryColor }}>
                        Remise campagne marketing :
                    </p>
                    <span style={{ color: mainColor.secondaryColor }}>
                        - {displayPriceFormat(order?.marketingCampaignPromoAmount)}
                    </span>
                </p>
            )}

            {renderDashedHr(shouldShowHrBeforeDelivery)}

            {(hasDelivery || isClickAndCollectPromo) && (
                <p style={classes.orderDetailStyle}>
                    <p>Frais de livraison :</p>
                    {displayPriceFormat(userServicePrice)}
                </p>
            )}

            {hasFees && (
                <p style={classes.orderDetailStyle}>
                    <p>Frais & services :</p>
                    {displayPriceFormat(managementFee)}
                </p>
            )}

            {hasFreeDelivery && (
                <>
                    {renderDashedHr(true)}
                    <p style={classes.orderDetailStyle}>
                        <p style={{ color: mainColor.secondaryColor }}>
                            Livraison offerte :
                        </p>
                        <span style={{ color: mainColor.secondaryColor }}>
                            - {displayPriceFormat(userServicePrice)}
                        </span>
                    </p>
                </>
            )}

            {isClickAndCollectPromo && (
                <>
                    {renderDashedHr(true)}
                    <p style={classes.orderDetailStyle}>
                        <p>Promotion :</p>
                        {hasPromoCode}
                    </p>
                </>
            )}
        </>
    );
};
